import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { ContextStore } from "../../../../../../react-core/Flux/Variables";
import { RoleStatus } from "../../../../../../Wrap/Constants/Enums/RoleStatus";
import { RoleType } from "../../../../../../Wrap/Constants/Enums/RoleType";
import { AccountRoleByActorDetails } from "../../../../../../Wrap/Models/Domains/Account/AccountRoleByActorDetails";
import { AccountRoleDispatcher } from "./Variable";

export interface AccountRoleStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: Array<AccountRoleByActorDetails>;
}

export class AccountRoleStatic extends BaseStore<AccountRoleStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(AccountRoleDispatcher, (actionData) => this.onAccountRoleStoreResponse(actionData));
    }

    public getLastResult(): AccountRoleStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public canEditForAdv(): boolean {
        if (ContextStore.getContext().isAdminUser) {return true;}
        if (!this.getState().data) {return false;}
        if (this.getState().data.length == 0) {return true;}
        return this.getState().data.some(
            (x) =>
                x.AccountRoleStatus == RoleStatus.Active &&
                [
                    RoleType.IndividualAccountHolder,
                    RoleType.JointAccountHolder,
                    RoleType.TrustAccountHolder,
                    RoleType.Trustee,
                    RoleType.Settlor,
                    RoleType.Beneficiary,
                    RoleType.AdditionalBeneficiary,
                    RoleType.AccountAccess,
                    RoleType.AccountAccessLegacy,
                ].includes(x.AccountRoleType)
        );
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): AccountRoleStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onAccountRoleStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
